'use strict';

var $ = require('jquery');

function init() {
	
	var $window = $(window);
	
	/* 
	 * 
	 * Callout sizing
	 * 
	 *  */
	
	var $callout = $('.callout .callout-text');
		
	
	if ( $callout.length > 1 ){
		
		var calloutHeights = [];
		
		var updateCalloutHeights = function($elems, extraHeight){
			var elemHeights = [];
			$elems.removeAttr('style');
			$elems.each(function(){
				elemHeights.push($(this).innerHeight());
			});
			var minElemHeight = Math.max.apply(Math, elemHeights);
			$elems.css({
				'height' : (minElemHeight + extraHeight) + 'px'
			});
		};
		
		updateCalloutHeights($callout, 0);
		
		$window.resize(function(){
			updateCalloutHeights($callout, 0);
		});
		
		
	}
	
	/* Phoenix - Persist Form */

	var phoenixResidence = phoenixResidence || {};

	var fillForm = function($form, formData) {
		for (var prop in formData) {
			var value = formData[prop];

			// Fill fields
			var field = $form.find('[name="' + prop + '"]');
			if (typeof field !== 'undefined' && typeof field.prop('tagName') !== 'undefined') {
				var tagName = field.prop('tagName').toLowerCase();
				if (tagName === 'input') {
					var type = field.prop('type');
					if (type === 'radio' || type === 'checkbox') {
						field.prop('checked', false);
						field.filter('[value="' + value + '"]').prop('checked', true);
					} else {
						field.val(value);
					}
				} else {
					// textarea, select
					field.val(value);
				}
			}
		}
	};

	phoenixResidence.setupPersistForm = function($){
		var $persistFormField = $('input[name="persistForm.name"]');
		if ($persistFormField.length === 0) {
			return;
		}

		var baseHref = $('base').attr('href');

		var ajaxPersistForm = function(action, $form) {
			var data = 'action=' + action + '&' + $form.serialize();

			$.ajax({
				type: 'post',
				url: baseHref + '/form-data',
				data: data,
				dataType: 'json'
			})
			.done(function(data, textStatus, jqXHR) {

				// If form has been submitted then done allow it to be edited.
				if (typeof data.status !== 'undefined' && data.status === 'SUBMITTED') {
					$('#employment input, #employment select, #employment textarea').attr('readonly', 'readonly');
				}

				if (typeof data.data !== 'undefined') {
					var formData = data.data;
					fillForm($form, formData);
				}
			})
			.fail(function(jqXHR, textStatus, errorThrown) {
				if (typeof console !== 'undefined') {
					console.log('AJAX Failed: ' + textStatus + ' -- ' + errorThrown);
				}
			});
		}; //End ajaxPersistForm()

		// Setup each field to trigger saving of data
		$persistFormField.each(function(i){
			var $this = $(this);
			var name = $this.val();

			var $form = $this.closest('form');

			ajaxPersistForm('load', $form);

			var saveTimeout;
			var saveFunction = function() {
				ajaxPersistForm('save', $form);
			};
			$form.find('input, select, textarea, select').change(function() {
				if (typeof saveTimeout !== 'undefined') {
					clearTimeout(saveTimeout);
				}
				saveTimeout = setTimeout(saveFunction, 1500);

			});
		});


		// Additional form setup.
		(function() {
			function getURLParameter(name) {
				return decodeURI(
					(RegExp(name + '=' + '(.+?)(&|$)').exec(window.location.search) || [, null])[1]
				);
			}

			// Auto populate position field.
			var positionParam = getURLParameter('position');
			if ( positionParam !== 'null' && positionParam !== '') {
				$('.positionApplyingForFieldArea input').val(positionParam);
			}

			var $field = $('#employment input[type="text"], #employment textarea');

			var generateStaticContent = function($elem) {
				$elem.each(function(){
					var $this = $(this);
					var val = $this.val();
					var $parent = $this.parent();
					if (val !== null && val !== '') {
						$parent.find('.static-form-value').remove();
						$parent.append('<p class="static-form-value">' + val + '</p>');
					}

				});
			};

			generateStaticContent($field);

			$field.on('change', function() {
				generateStaticContent($(this));
			});

		})();

	};
	
	
	
}
module.exports = {
	init : init
};
